"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateBalance = updateBalance;
exports.updateFormattedBalance = updateFormattedBalance;
var _types = require("./types");
function updateBalance(balanceInfo) {
  return {
    type: _types.UPDATE_BALANCE,
    payload: balanceInfo
  };
}
function updateFormattedBalance(formattedBalance) {
  return {
    type: _types.UPDATE_FORMATTED_BALANCE,
    payload: formattedBalance
  };
}
//# sourceMappingURL=actions.js.map